import { useMemo } from 'react';
import { GROUPBY } from '../../../../constants/Reports';

export const useOvertimeData = (overtimeData, groupby, columns) =>
  useMemo(() => {
    if (!overtimeData) return [];

    const isGroupedByEmp = groupby.id === GROUPBY[0].value;

    return Object.entries(overtimeData).map(([key, value]) => {
      const data = value.map((item) => {
        const [date, shiftOrName, quantityOrShift, quantity] = item;

        return isGroupedByEmp
          ? {
              date,
              shift: shiftOrName,
              quantity: quantityOrShift,
            }
          : {
              date,
              name: shiftOrName,
              shift: quantityOrShift,
              quantity,
            };
      });

      const footer = Array.isArray(columns)
        ? columns.map((col) => {
            if (col.field === 'quantity') {
              const total = data.reduce((acc, row) => {
                const val = Number(row[col.field]);
                return !Number.isNaN(val) ? acc + val : acc;
              }, 0);
              return +total.toFixed(2);
            }
            return '';
          })
        : undefined;

      return { name: key, data, footer };
    });
  }, [overtimeData, groupby.id, columns]);
